import React from 'react';
import LoadingCell from '../loadingCell/loadingCell';
import { Link } from 'react-router-dom';

import '../textCell/textCell.scss';

const LinkCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }

  if (props.dataItem[props.field] === undefined && props.treelist) return <td></td>;
  if (props.dataItem[props.field] === undefined && props.grid) return <td></td>;
  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  return (
    <td style={props.style} className={props.className}>
      {props.field.startsWith('measure') ? (
          <Link to={props.to ? props.to : ''} className="link text-cell alignment-right">
            {props.dataItem[props.field || '']}
          </Link>
      ) : (
        <Link to={props.to ? props.to : ''} title={props.useTooltip ? props.dataItem[props.field] : ''} className="link text-cell">
          {props.dataItem[props.field || '']}
        </Link>
      )}
    </td>
  );
};

export default LinkCell;
